import type { IconData } from '@stacksjs/iconify-core'

export const cut: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M104 320a88.067 88.067 0 1 0 75.607 43.02L260 282.627L425.373 448H448v-22.627L282.627 260L448 94.627V72h-22.627L260 237.373l-83.523-83.523a88.088 88.088 0 1 0-22.627 22.627L237.373 260l-78.919 78.919A87.57 87.57 0 0 0 104 320m0-160a56 56 0 1 1 56-56a56.063 56.063 0 0 1-56 56m0 304a56 56 0 1 1 56-56a56.063 56.063 0 0 1-56 56\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default cut
